<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <template v-slot:activator="{ on }">
            <v-btn icon fab dark small :color="mode.color" v-on="on">
                <v-icon>{{ mode.icon }}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ mode.action }} Relatório</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs4 sm4>
                            <v-text-field label="Prj # *" v-model="objRelatorio.projeto_id" required></v-text-field>
                        </v-flex>
                        <v-flex xs8 sm8>
                            <v-text-field label="Projeto *" v-model="objRelatorio.projeto" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 :sm8="objRelatorio._id">
                            <v-autocomplete
                                label="Funcionário *"
                                :items="funcionarios"
                                v-model="objRelatorio.usuario"
                                required
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm4 v-if="objRelatorio._id">
                            <v-autocomplete
                                label="Status *"
                                :items="['Aberto', 'Fechado']"
                                v-model="objRelatorio.status"
                                required
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
                <small>* Campos obrigatórios</small>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required        } from 'vuelidate/lib/validators';
import Util                from '@/util';
import modalMixin          from '@/mixins/modalMixin';

export default {
    name        : 'RelatoriosModal',
    mixins      : [modalMixin, validationMixin],
    validations : {
        objRelatorio : {
            projeto_id : {
                required
            },
            projeto    : {
                required
            },
            usuario    : {
                required
            }
        }
    },
    props       : {
        relatorio  : {
            type    : Object,
            default : function () {
                return {
                    _id           : null,
                    projeto_id    : '',
                    projeto       : '',
                    usuario       : '',
                    saldo         : '',
                    dt_fechamento : '',
                    status        : 'Aberto'
                }
            },
        },
        reloadGrid : Function
    },
    methods     : {
        getFuncionarios() {
            this.$axios.get('usuarios?filter={"perfis":"Funcionário"}').then(
                response => {
                    this.funcionarios = response.data.items.map(funcionario => {
                        return { ...funcionario, value: funcionario._id, text: funcionario.nome}
                    });
                }
            );
        },
        validatePwd() {
            if (this.mode.action == 'Cadastrar' &&
                (this.objRelatorio.senha == "" && this.objRelatorio.confirmaSenha == "")
            ) {
                return {
                    valid : false,
                    msg   : 'Ao cadastrar, é obrigatório informar a senha.'
                }
            } else if (this.objRelatorio.senha !== this.objRelatorio.confirmaSenha) {
                return {
                    valid : false,
                    msg   : 'A senha não foi confirmada!'
                }
            } else {
                return {
                    valid : true
                }
            }
        },
        setObjRelatorio() {
            if (this.relatorio._id) {
                this.objRelatorio = JSON.parse(JSON.stringify(this.relatorio));
                this.objRelatorio.usuario = this.objRelatorio.usuario._id ? this.objRelatorio.usuario._id : this.objRelatorio.usuario;
            } else {
                this.resetObjRelatorio();
            }
        },
        resetObjRelatorio() {
            this.objRelatorio = {
                _id           : null,
                projeto_id    : '',
                projeto       : '',
                usuario       : '',
                saldo         : '',
                dt_fechamento : '',
                status        : 'Aberto'
            };
        },
        save() {
            this.saving = true;
            const id = (this.objRelatorio._id ? `/${this.objRelatorio._id}` : '');
            if (this.objRelatorio.status == 'Aberto') {
                this.objRelatorio.dt_fechamento = '';
            } else if (!this.objRelatorio.dt_fechamento) {
                this.objRelatorio.dt_fechamento = new Date().toISOString();
            }
            this.$axios[this.mode.method](`relatorios${id}`, this.objRelatorio).then(response => {
                this.toggleDialog();
                // this.resetObjRelatorio();
                this.reloadGrid();
                window.getApp.snackbar = {
                    show  : true,
                    color : 'green',
                    text  : this.mode.snack
                };
            }).catch(error => {
                const errorMsg = Util.getErrorMsg(error.response.data);
                console.error(errorMsg.detailedMsg);
                // this.toggleDialog();
                window.getApp.snackbar = {
                    show      : true,
                    color     : 'red',
                    text      : errorMsg.msg
                };
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    computed    : {
        id() {
            return this.objRelatorio._id;
        },
    },
    data() {
        return {
            objRelatorio : {},
            funcionarios : []
        };
    },
    mounted() {
        this.setObjRelatorio();
    },
    watch       : {
        dialog(novo, antigo) {
            if (novo) {
                this.getFuncionarios();
                this.setObjRelatorio();
            }
        }
    }
};
</script>
